import type { TFunction } from 'i18next';

import {
    createDataTableColumnHelper,
    type DataTableColumnDef,
} from '@/components/organisms/DataTable';

import type { BioscopeRow } from '../bioscopeRows';
import BooleanStatusIcon from '../components/BooleanStatusIcon';

const columnHelper = createDataTableColumnHelper<BioscopeRow>();

/** What each bioscope is fitted with: fin clip classification, winch, UVC, jetpack. */
export function equipmentColumns(t: TFunction): DataTableColumnDef<BioscopeRow>[] {
    return columnHelper.columns([
        columnHelper.accessor((row) => Boolean(row.configuration?.config?.classifyAdiposeFin), {
            id: 'finClip',
            header: t('internal.bioscopeList.columns.finClip'),
            cell: (info) => (
                <BooleanStatusIcon
                    active={info.row.original?.configuration?.config?.classifyAdiposeFin === true}
                    activeLabel={t('internal.bioscopeList.finClipActive')}
                    inactiveLabel={t('internal.bioscopeList.finClipInactive')}
                />
            ),
        }),
        columnHelper.accessor((row) => Boolean(row.winchExists), {
            id: 'winch',
            header: t('internal.bioscopeList.columns.winch'),
            cell: (info) => (
                <BooleanStatusIcon
                    active={info.row.original.winchExists === true}
                    activeLabel={t('internal.bioscopeList.winchConnected')}
                    inactiveLabel={t('internal.bioscopeList.winchNotConnected')}
                />
            ),
        }),
        columnHelper.accessor((row) => row.winchId, {
            id: 'winchId',
            header: t('internal.bioscopeList.columns.winchId'),
        }),
        columnHelper.accessor((row) => Boolean(row.isTestBioscope), {
            id: 'testBioscope',
            header: t('internal.bioscopeList.columns.testBioscope'),
            cell: (info) => (
                <BooleanStatusIcon
                    active={info.row.original.isTestBioscope === true}
                    activeLabel={t('internal.bioscopeList.isTestBioscope')}
                    inactiveLabel={t('internal.bioscopeList.isNotTestBioscope')}
                />
            ),
        }),
        columnHelper.accessor((row) => Boolean(row.uvc), {
            id: 'uvc',
            header: t('internal.bioscopeList.columns.uvc'),
            cell: (info) => (
                <BooleanStatusIcon
                    active={info.row.original.uvc === true}
                    activeLabel={t('internal.bioscopeList.uvcEnabled')}
                    inactiveLabel={t('internal.bioscopeList.uvcDisabled')}
                />
            ),
        }),
        columnHelper.accessor((row) => row.jetpackVersion, {
            id: 'jetpackVersion',
            header: t('internal.bioscopeList.columns.jetpackVersion'),
        }),
    ]);
}
